<template>
<div class="bg">
  <div class="title-text">
    <p class="fs-caveat">Vintage Colection</p>
    <span class="marker">
      <span>SNEAKERS  <br>   </span>
       <span>SALE</span>
    </span>
    </div>
</div>


</template>

<script>

import AboutView from "@/views/AboutView.vue";

export default {
  components: {AboutView}


}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss" >
@import url('https://fonts.googleapis.com/css2?family=Caveat:wght@400..700&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Permanent+Marker&display=swap');
.bg{
  background-image: url(../../src/img/nike.jpeg);
  height: 95%;
}
.title-text{
  font-family:"Caveat" ;
  font-size: 65px;
  width: 500px;
  position: relative;
  left: 25%;
  top: 35px;
  transform: rotate3d(0, 1, 1, 324deg);
}
.marker{
  font-family: "Permanent Marker", cursive;
  font-weight: 400;
  font-style: normal;
  color: #b6971a;
  width: 300px;
}
</style>
